import { useState } from 'react';
import ImageViewer from '../../Style-guide/ImageViewer';
import Title from '../../Style-guide/Title';
import CourtPreview from '../CourtPreview';
import CardWrapper from './style/courtCardWrapper';

const CourtCard = ({ data, colAmount, onClick }) => {
  const [showPreview, setShowPreview] = useState(false);
  const hasPreview = !onClick;
  const { mainImage, galleryImage1, galleryImage2 } = data || {};
  const imageSrc =
    [mainImage, galleryImage1, galleryImage2].find((img) => img?.data)?.data || null;

  const imageOrPlaceholder = imageSrc ? (
    <ImageViewer className='card-image' src={imageSrc} alt='court' />
  ) : (
    <div className='card-image no-image' />
  );

  return (
    <>
      <CardWrapper
        role='button'
        onClick={onClick ?? (() => setShowPreview(true))}
        colAmount={colAmount}
      >
        <Title size='SM' className={!imageSrc && 'no-image-title'}>
          {data.name}
        </Title>
        {imageOrPlaceholder}
      </CardWrapper>

      {hasPreview ? (
        <CourtPreview
          show={showPreview}
          onClose={() => setShowPreview(false)}
          data={data}
        />
      ) : null}
    </>
  );
};

export default CourtCard;
